export var Variances;
(function (Variances) {
    Variances["size"] = "Size";
    Variances["color"] = "Color";
    Variances["material"] = "Material";
    Variances["title"] = "Title";
})(Variances || (Variances = {}));
